import { inject, Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { BaseMainTableDataService } from '@app/main/main-content/main-table/services/base-main-table-data.service';
import { ICorrelationTableData } from '@app/main/leak-detection/interfaces/correlation-table-data';
import { LeakDetectionTabsPanelService } from '@app/main/leak-detection/services/leak-detection-tabs-panel/leak-detection-tabs-panel.service';
import { selectLoggerDeploymentEntities } from '@app/main/main-screen/store/data/logger-deployments/logger-deployments.selectors';
import { withLatestFrom } from 'rxjs/operators';
import { CommonStateStatus } from '@app/core/enums/common-state-status.enum';

@Injectable({
  providedIn: 'root',
})
export class LeakDetectionTableCorrelationsDataService extends BaseMainTableDataService<ICorrelationTableData> {
  public leakDetectionTabsPanelService = inject(LeakDetectionTabsPanelService);

  public getData(): Observable<ICorrelationTableData[]> {
    return this.leakDetectionTabsPanelService.correlations$.pipe(
      withLatestFrom(this.store.select(selectLoggerDeploymentEntities)),
      filter(([correlations]) => correlations !== null),
      map(([correlations, loggerDeploymentsMap]) => {
        return correlations.map(correlation => {
          return {
            id: correlation.id,
            correlationType: correlation.correlationType,
            qualityStatus: correlation.suppressed ? CommonStateStatus.Normal : correlation.qualityStatus,
            quality: correlation.quality,
            logger1SerialNo: loggerDeploymentsMap[correlation.logger1DeploymentId]?.serialNo,
            logger2SerialNo: loggerDeploymentsMap[correlation.logger2DeploymentId]?.serialNo,
            soundSignalStartAt: correlation.soundSignalStartAt,
            distanceL1: correlation.distanceL1,
            distanceL2: correlation.distanceL2,
            centerDistance: correlation.centerDistance,
            pipeLength: correlation.pipeLength,
            pipeProvided: correlation.pipeProvided,
            customCoordinates: correlation.customCoordinates,
            coordinates: correlation.coordinates,
            comment: correlation.comment?.content,
            raw: correlation,
            consistency: correlation.consistency,
            maxTime: correlation.maxTime,
            maximum: correlation.maximum,
            soundVelocity: correlation.soundVelocity,
            overlap: correlation.overlap,
            corrLength: correlation.corrLength,
            delayMax: correlation.delayMax,
            whyUnsynchronized: correlation.whyUnsynchronized,
          };
        });
      })
    );
  }
}
